export const MIN_STUDY_REPORT_SIZE = 10;
